import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Star } from "lucide-react";
import { googleSession } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    googleSession(sessionId)
      .then((u) => {
        setUser(u);
        navigate("/profile", { replace: true, state: { user: u } });
      })
      .catch(() => navigate("/", { replace: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="grid min-h-screen place-items-center bg-[#FFFDF6]" data-testid="auth-callback">
      <div className="text-center">
        <Star className="mx-auto h-12 w-12 animate-pulse fill-[#FFC107] text-[#FFC107]" />
        <p className="mt-4 font-display text-lg font-semibold text-slate-700">
          Signing you in with Google…
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
